import { get, put, post, patch } from '@core/request';

//获取专家列表
export const getAllExpertsApi = params => {
    return get('/conference/boss/guests/expert-list', params);
};

export const saveExpertsApi = params => {
    return post('/conference/boss/guests/batchSave', params);
};

export const guestListApi = params => {
    return post('/conference/boss/guests/list', params);
};

/** 添加或编辑嘉宾备注 */
export const updateGuestRemarksApi = data => patch('/conference/boss/guests/remarks', data);

export const guestDelApi = params => {
    return put('/conference/boss/guests/delete', params);
};

// 批量删除嘉宾
export const batchDeleteGuestsApi = params => {
    return post('/conference/boss/guests/batchDelete', params);
};

export const guestMessageOnceApi = params => {
    return get('/conference/boss/guests/getOne', params);
};

export const guestMessageChangeApi = params => {
    return put('/conference/boss/guests/update', params);
};
export const guestAllSureApi = params => {
    return post('/conference/boss/guests/batchAgendaSave', params);
};

export const guestDateApi = params => {
    return post('/conference/boss/agendaguests/getAgendaGuestsList', params);
};

export const guestDateUpdateApi = params => {
    return put('/conference/boss/agendaguests/update', params);
};

// 嘉宾行程列表
export const guestjourneysApi = params => {
    return get('/conference/boss/guestjourneys/list', params);
};

// 嘉宾行程中获取单个行程信息
export const fetchGuestJourney = params => get('/conference/boss/guestjourneys/getInfo', params);

// 嘉宾行程中保存行程信息
export const saveGuestJourney = data => post('/conference/boss/guestjourneys/save', data);

// 嘉宾行程中更新专家证件信息
export const updateGuestJourneyIdCard = data => post('/user/ssomemberexperts/updateIdcard', data);

// 嘉宾行程单设置
export const updateGuestJourneySettingsApi = data => put('/conference/boss/conferences/update-guest-journey-settings', data);

// 嘉宾行程单导入
export const GuestJourneyImportApi = data => post('/conference/boss/guestjourneys/import', data);

// 嘉行程快捷录入
export const extractGuestJourneyInfo = data => post('/conference/boss/guestjourneys/ai-input', data);

// 嘉宾行程单导入校验
export const GuestJourneyImportCheckApi = data =>
    post('/conference/boss/guestjourneys/import-check', data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

// 嘉宾行程单导出
export const GuestJourneyExportApi = data => get('/conference/boss/guestjourneys/exportGuestJourneysByConferenceId', data);

// 嘉宾行程单合计信息
export const GuestJourneyTotalApi = data => get('/conference/boss/guestjourneys/getTotal', data);

// 更新嘉宾行程特别提醒
export const updateGuestJourneyRemindApi = data => post('/conference/boss/guestjourneys/update-remind', data);

// 嘉宾导出
export const exportGuestsApi = data => get('/conference/boss/guests/download', data, { responseType: 'blob' });

// 行程提醒设置
export const updateGuestJourneySettings = data => put('/conference/boss/conferences/update-guest-journey-agenda-settings', data);

// 行程提醒下载
export const journeySettingDownloadApi = data => get('/conference/boss/conferences/word/journey-agenda-download', data, { responseType: 'blob' });

// 嘉宾同步报名
export const sync2registrationApi = data => {
    return post(`/conference/boss/guests/sync2registration`, data);
};

// 批量更换邀请方
/**
 * @deprecated 功能已废弃：请改用“新增邀请方/移除邀请方/重置邀请方”接口组合实现。
 * 前端 UI 已移除“更换邀请方”入口，此接口仅为兼容历史保留。
 */
export const setInvitingOrgsApi = data => {
    return put(`/conference/boss/guests/setInvitingOrgs`, data);
};

// 会议嘉宾-新增邀请方
export const addInvitationOrgsApi = data => {
    return post(`/conference/boss/guests/addInvitationOrgs`, data);
};

// 会议嘉宾-移除邀请方
export const removeInvitationOrgsApi = data => {
    return post(`/conference/boss/guests/removeInvitationOrgs`, data);
};

// 会议嘉宾-重置邀请方
export const resetInvitationOrgsApi = data => {
    return post(`/conference/boss/guests/resetInvitationOrgs`, data);
};

// 批量修改劳务需求
// laborFeeDemand: 0=待定，1=需要，2=不需要
// 仅更新当前值与目标值不一致的记录，返回实际被修改的专家ID列表
export const batchUpdateGuestLaborDemandApi = data => {
    return post('/conference/boss/guests/updateLaborFeeDemand', data);
};

// 劳务需求变更预检
// laborFeeDemand=1时，对当前劳务需求不为1的专家判断是否有会议任务，按有/无会议任务分两个列表返回
// laborFeeDemand=2时，对当前劳务需求不为2的专家判断是否有付款申请记录，按有/无付款申请记录分两个列表返回
// 响应 data: { withTaskExperts, withoutTaskExperts, withPaymentExperts, withoutPaymentExperts }
export const checkGuestLaborDemandChangeableApi = data => {
    return post('/conference/boss/guests/checkLaborFeeDemand', data);
};

/**
 *
 * 嘉宾行程管理
 * @returns
 */

// 批量更换行程需求
export const batchUpdateNeedsApi = data => {
    return post(`/conference/boss/guestjourneys/batch-update-needs`, data);
};

// 分配服务商
export const conferencePartnersApi = data => {
    return get(`/conference/boss/conferencepartners/list`, data);
};

// 分配服务商保存设置
export const savePartnersApi = data => {
    return put(`/conference/boss/guests/setGuestPartnerIds`, data);
};

// 修改会议服务商授权截止时间
export const updatePartnerDeadlineApi = data => {
    return put(`/conference/boss/conferences/update-partner-auth-deadline`, data);
};

// 保存服务商授权关联
export const saveConferencePartnersApi = data => {
    return post(`/conference/boss/conferencepartners/save`, data);
};

// 删除服务商授权关联
export const deleteConferencePartnersApi = data => {
    return post(`/conference/boss/conferencepartners/delete`, data);
};

// 编辑服务商授权关联
export const updateConferencePartnersApi = data => {
    return post(`/conference/boss/conferencepartners/update`, data);
};

// 获取服务商列表
export const getPartnersApi = data => {
    return get(`/conference/boss/partners/list`, data);
};

// 医会议已关联（新增）的授权服务商
export const listWithConferenceInfoApi = data => {
    return get(`/conference/boss/conferencepartners/listWithConferenceInfo`, data);
};

// 酒店管理 - 保存
export const saveHotelApi = data => {
    return post(`/conference/boss/hotels/save`, data);
};

// 酒店管理 - 删除
export const deleteHotelApi = data => {
    return post(`/conference/boss/hotels/delete`, data);
};

// 酒店管理 - 修改
export const updateHotelApi = data => {
    return post(`/conference/boss/hotels/update`, data);
};

// 酒店管理 - 获取列表
export const listHotelApi = data => {
    return get(`/conference/boss/hotels/list`, data);
};

// 酒店管理 - 获取酒店详情
export const getHotelInfoApi = data => {
    return get(`/conference/boss/hotels/info`, data);
};

// 酒店管理 - 批量更新时间
export const updateHotelTimeApi = data => {
    return put(`/conference/boss/conferences/update-hotel-date`, data);
};

// 酒店管理 - 以天为单位的列表
export const getHotelListDayApi = data => {
    return get(`/conference/boss/hotels/list-day`, data);
};

// 酒店房型 - 保存
export const saveHotelRoomTypesApi = data => {
    return post(`/conference/boss/hotelroomtypes/save`, data);
};

// 酒店房型 - 删除
export const deleteHotelRoomTypesApi = data => {
    return post(`/conference/boss/hotelroomtypes/delete`, data);
};

// 酒店房型 - 修改
export const updateHotelRoomTypesApi = data => {
    return post(`/conference/boss/hotelroomtypes/update`, data);
};
